import React from 'react';
import { Section, Image, TeslaText as Text, TeslaButton as Button } from 'components';

import * as styles from './styles.module.scss';

const coverStyle = { position: 'absolute' };
const coverImgStyle = { objectFit: 'cover', objectPosition: 'center center' };
const containImgStyle = { objectFit: 'contain', objectPosition: 'center center' };

const BannerGfv = (props) => {
  const { data } = props;
  const { primary } = data;
  const {
    backgroundimage: backgroundImage,
    mobilebackgroundimage: mobileBackgroundImage,
    title,
    body1,
    btn_text: btnText,
    link,
  } = primary;

  const hasBackgroundImage = backgroundImage?.url;
  const hasMobileImage = mobileBackgroundImage?.url;
  const hasCta = btnText?.text && link?.url;

  return (
    <Section sliceName="BannerGfv" className={styles.section} noContainer>
      <div className={styles.banner}>
        {hasBackgroundImage ? (
          <div className={`${styles.imageWrapper} ${hasMobileImage ? styles.desktopOnly : ''}`}>
            <Image image={backgroundImage} style={coverStyle} imgStyle={coverImgStyle} />
          </div>
        ) : null}
        {hasMobileImage ? (
          <div className={`${styles.imageWrapper} ${styles.mobileOnly}`}>
            <Image image={mobileBackgroundImage} />
          </div>
        ) : null}
        <div className={styles.content}>
          <Text className={styles.title} text={title.text} />
          <Text className={styles.body} text={body1.text} />
          {hasCta ? (
            <Button to={link.url} theme="yellow">
              {btnText.text}
            </Button>
          ) : null}
        </div>
      </div>
    </Section>
  );
};

export default BannerGfv;
